import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, Subscription, take } from 'rxjs';

export const hasEmptyRequiredField = (controls: Record<string, AbstractControl>): boolean => {
	return Object.values(controls).some((control) => control.hasError('required'));
};

export const createPendingSubmitWaiter = (form: AbstractControl, onReady: () => void) => {
	let subs: Subscription | null = null;

	return function waitForPendingAndSubmit(): void {
		if (subs) {
			return;
		}

		subs = form.statusChanges.pipe(distinctUntilChanged(), take(1)).subscribe(() => {
			onReady();
			subs?.unsubscribe();
			subs = null;
		});
	};
};
